import { Outlet } from '@tanstack/react-router'
import { MobileNav_M10_15 } from '@/components/layout/MobileNav'
import { DesktopSidebar_M10_16 } from '@/components/layout/DesktopSidebar'
import { PreviewBanner_M10_33 } from '@/components/domain/PreviewBanner'
import { Toaster } from '@/components/ui/toaster'

export function AppLayout_M10_18() {
  return (
    <div className="flex min-h-screen bg-background text-foreground">
      {/* Subtle ambient background glow */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <div className="absolute top-0 left-0 h-[500px] w-[500px] rounded-full bg-primary/3 blur-[150px]" />
        <div className="absolute bottom-0 right-0 h-[400px] w-[400px] rounded-full bg-secondary/3 blur-[150px]" />
      </div>

      <DesktopSidebar_M10_16 />
      <div className="relative z-10 flex-1 min-w-0 flex flex-col">
        <PreviewBanner_M10_33 />
        <main className="flex-1">
          <Outlet />
        </main>
      </div>
      <MobileNav_M10_15 />
      <Toaster />
    </div>
  )
}
